var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pa-0",attrs:{"id":"home"}},[_c('hero'),_c('welcome'),_c('demo'),_c('features'),_c('pricing'),_c('try-it')],1)}
var staticRenderFns = []

export { render, staticRenderFns }